export class ZipCodeFloridaModel {
  public Zip: string;
  public City: string;
  public County: string;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/pages/zip-code-florida/zip-code-florida.model.ts